import React from 'react';

import buttonStyles from "./AlmeStyledButton.styles";
import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Button, ButtonProps } from "@material-ui/core";
import { FocusComponentProps } from '../../../models/ComponentProps';

export interface AlmeStyledButtonProps extends FocusComponentProps {
    id?: string;
    className?: string;
    color?: ButtonProps['color'];
    variant?: ButtonProps['variant'];
    fullWidth?: ButtonProps['fullWidth'];
    key: string;
    href?: ButtonProps['href'];
    target?: '_self' | '_blank';
    size?: ButtonProps['size'];
    endIcon?: ButtonProps['endIcon'];
    onClick?: ButtonProps['onClick'];
}

interface StyledButtonProps extends AlmeStyledButtonProps, WithStyles<typeof buttonStyles> { }

const AlmeStyledButton: React.FC<StyledButtonProps> = (props: StyledButtonProps) => {
    const { classes, ...other } = props;
    return <Button {...other}/>;
};

export default withStyles(buttonStyles)(AlmeStyledButton);